const findPaths = (props, url) => {
  return '[NOPATH]';
  const report = props.Session.RX_Board.filter(
    item => item.url === url
  ).first()
  const board = props.Session.RX_Folder.filter(x => x.boards.includes(String(report.id))).first();
  if (!board) {
    return 'Dashboard > Main'
  }
  const folder = props.Session.RX_Folder.filter(x => x.children.includes(String(board.id))).first()
  const menu = props.Session.RX_Folder.filter(x => x.children.includes(String(folder.id))).first()
  const fullPath = `${menu ? menu.label : '?'} > ${folder ? folder.label : '?'} > ${board ? board.label : '?'} > ${report ? report.name : ''}`

  return fullPath;
}


export { findPaths }


// WEBPACK FOOTER //
// ./src/lib/helpers.js